export default __webpack_public_path__ + "static/media/Aerial3.ee8bfa12.jpg";